import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { AgentActionType, type IAgentActionSettings } from 'entities/AgentActions'
import { type Tag } from 'entities/Tags/model/Tag'
import { ActionMessage } from './ActionMessage'
import { ActionTags } from './ActionTags'
import styles from './styles.module.scss'

type IActionsListProps = {
  actions: IAgentActionSettings[] | null
  getFutureActionsTags: (ids: number[]) => Promise<Tag[]>
}

export const ActionsList = observer(({ actions, getFutureActionsTags }: IActionsListProps) => {
  if (!actions?.length) {
    return (
      <Typography
        ariaLabel={'successActionEmpty'}
        variant={'body-md-regular'}
        className={styles.empty}
      >
        Please add actions
      </Typography>
    )
  }

  return (
    <>
      {actions.map((action, index) => {
        switch (action.type) {
          case AgentActionType.AddTag:
            return (
              <ActionTags
                key={index}
                name={'Add tags'}
                placeholder={'Please add tags'}
                futureTags={getFutureActionsTags(action.settings.tag_ids)}
              />
            )
          case AgentActionType.RemoveTag:
            return (
              <ActionTags
                key={index}
                name={'Remove tags'}
                placeholder={'Please add tags'}
                futureTags={getFutureActionsTags(action.settings.tag_ids)}
              />
            )
          case AgentActionType.ContactNote:
            return (
              <ActionMessage
                key={index}
                name={'Add contact note'}
                message={action.settings.note}
                placeholder={'Please add note'}
              />
            )
          case AgentActionType.SendMessage:
            return (
              <ActionMessage
                key={index}
                name={'Send message'}
                message={action.settings.message}
                placeholder={'Please add message'}
              />
            )
          default:
            return null
        }
      })}
    </>
  )
})
